import { Onboarding } from './components/Onboarding';
import { CreatorLinks } from './components/CreatorLinks';
import { CreatorInformationSections } from './staticContent/CreatorInformationSections';
import { Header } from './components/Header';
import { CaseStudies } from './components/CaseStudies';
import { IOSAppQrCodeModal } from './components/IosAppQrCodeModal';
import { Feedback } from './components/Feedback';
import { OfferModal } from './components/offerModal/OfferModal';
import { GoLiveModal } from './components/GoLiveModal';
import { LiveSuccessModal } from './components/LiveSuccessModal';
import { EducationCloseConfirmationModal } from './components/EducationCloseConfirmationModal';

import handbook from './components/handbook.png';
import growthClub from './components/new-year-challenge.png';
import { FeatureSection } from './components/FeatureSection';
import { OnboardingCard } from './components/OnboardingCard';
import { cardsSection, externalUrls } from './mappers';
import { WebinarModal } from './components/WebinarModal';
import { trackEvent } from '@services/tracking';
import { SuperTooltipModal } from './components/SuperTooltipModal';
import { HomeVM } from './home.viewModel';
import { BlackFridayChallenge } from './modals/BlackFridayChallenge';

export const HomeView = (p: HomeVM) => {
  return (
    <div className="w-full flex flex-col gap-8 max-w-[1200px] mx-auto">
      <Header {...p.headline} />
      <Onboarding {...p.onboarding} />
      <CreatorLinks {...p} />

      <div className="flex gap-4 md:flex-row flex-col">
        {cardsSection.map((card) => (
          <OnboardingCard
            key={card.title}
            title={card.title}
            description={card.description}
            image={card.image}
            link={card.link}
            onClick={() => {
              trackEvent({
                type: 'Onboarding Tile Tapped',
                payload: {
                  Title: card.title,
                  Source: p.isLive ? 'Post-Launch' : 'Pre-Launch',
                },
              });
            }}
          />
        ))}
      </div>

      <FeatureSection
        title="Need more help?"
        description="Explore our video library in the Playbook Handbook to help answer your questions "
        onClick={() => {
          window.open(externalUrls['handbook'], '_blank');
          trackEvent({
            type: 'Onboarding Guide Tapped',
            payload: {
              Source: p.isLive ? 'Post-Launch' : 'Pre-Launch',
            },
          });
        }}
        ctaText="Go to Handbook"
        imageSrc={handbook}
      />

      <FeatureSection
        title="Join the New Year's Launch Challenge"
        description="Access step-by-step guidance, templates, and insider support to craft your New Year's drop, grow your audience, and boost your earnings — all within the Creator Community."
        onClick={() => p.dispatch('challengeJoined')}
        ctaText="Join the Challenge"
        imageSrc={growthClub}
        reverse
      />

      <Feedback {...p.feedback} influencerId={p.influencerId} />
      <CreatorInformationSections isLive={p.isLive} />
      <IOSAppQrCodeModal
        isOpen={p.openedModal === 'QrCode'}
        onClose={() => p.dispatch('closeModal')}
      />
      <OfferModal {...p.offerModal} />
      <EducationCloseConfirmationModal {...p.educationCloseConfirmation} />
      <GoLiveModal {...p.goLiveModal} />
      <LiveSuccessModal {...p.liveSuccessModal} />
      <WebinarModal
        isOpen={p.openedModal === 'Webinar'}
        onClose={() => p.dispatch('closeModal')}
      />
      <SuperTooltipModal
        isOpen={p.openedModal === 'SuperTooltip'}
        onClose={() => p.dispatch('closeModal')}
      />

      <BlackFridayChallenge
        isOpen={p.openedModal === 'BlackFridayChallenge'}
        onClose={() => p.dispatch('closeModal')}
      />

      <CaseStudies />
    </div>
  );
};
